import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Close } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, Button, DialogActions, Table, TableHead, TableRow, TableCell, TableBody, Typography, IconButton, Divider } from '@mui/material';
import ProjectDetailsFeeCreate from './ProjectDetailsFeeCreate';
import ProjectDetailsFeeItem from '../../../../components/items/ProjectDetailsFeeItem';

const styles = {
  container: {
    display: 'block',
  },
  content: {
    paddingY: 0,
  },
  actions: {
    paddingRight: '1rem'
  },
  title: {
    my: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  fieldWrapper: {
    px: '1rem'
  }
}

const ProjectDetailsFees = props => {
  const fees = useSelector(state => state.fees.list);
  const [openCreate, setOpenCreate] = useState(false);

  const handleClose = e => {
    e?.preventDefault();
    props.onClose();
  }

  const handleOpenCreate = () => setOpenCreate(true);
  const handleCloseCreate = () => setOpenCreate(false);

  return (
    <>
      <Dialog
        open={props.open}
        onClose={handleClose}
      >
        <DialogTitle>
        <Box sx={styles.title}>
            <Typography variant="h5">Fees</Typography>
            <IconButton onClick={handleClose}><Close /></IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.content}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Aplicación</TableCell>
                <TableCell>Valor</TableCell>
                <TableCell>Guardar</TableCell>
                <TableCell>Borrar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fees.map(fee => <ProjectDetailsFeeItem key={fee._id} {...fee} />)}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions sx={styles.actions}>
          <Button onClick={handleOpenCreate}>Añadir</Button>
        </DialogActions>
      </Dialog>
      <ProjectDetailsFeeCreate open={openCreate} onClose={handleCloseCreate} />
    </>
  );
}

export default ProjectDetailsFees;
